import React, { Suspense } from 'react';

const LazyWrapper = ({ children, fallback = <div>Loading...</div> }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

export default LazyWrapper;